<template>
	<div class="d-flex align-center">
		<ao-avatar
			v-if='image'
			class='mr-2'
			size='48'
			:image='image'
			imageCover
		/>
		<div>
			<div class="ao-h2 mb-1 text-textBody">{{ title }}</div>
			<ao-btn
				v-if='status'
				variant='tonal'
				density='compact'
				height='22'
				:color='status'
				class='ao-p4-medium py-1'
			>{{ subTitle }}</ao-btn>
			<div v-else
				class="ao-p2-medium text-textSecondary700">{{ subTitle }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PopupHeader',

	props: {
		image: {
			type: String,
			default: ''
		},
		tile: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
		},
		subTitle: {
			type: String,
		},
		status: {
			type: String
		},
	},
}
</script>
